import React, {useState} from 'react';
import {View, StyleSheet, TouchableOpacity} from 'react-native';
import Alert from "@/lib/Alert";
import {Image} from 'expo-image';
import {AppDataMediaItem} from "@/data/app-data-interfaces";
import {useCurrentTheme} from "@/theming/useCurrentTheme";
import {ThemeType} from "@/theming/baseTheme";
import {LoadSpinner} from "@/components/common/LoadSpinner";
import {OpenButton} from "@/components/common/OpenButton";
import {getVideoUrl} from "@/data/app-data-api";
import {useAddLastViewed} from "@/data/user-data-hooks";
import {openDocument} from "@/lib/utils";

interface MediaItemPreviewProps {
    item: AppDataMediaItem;
    orgId: string;
}

export const MediaItemPreview: React.FC<MediaItemPreviewProps> = ({
                                                                      orgId,
                                                                      item
                                                                  }) => {
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme);
    const [isLoading, setIsLoading] = useState(false);

    const addLastViewed = useAddLastViewed();


    const handleDownloadPress = async () => {
        addLastViewed.mutate({orgId, videoId: item.id});

        // @todo save that we downloaded this mediaitem already and
        // open instead of downloading again

        setIsLoading(true);

        try {
            const url = await getVideoUrl(item.id);
            await openDocument(url, item.name, item.type);
            // The player will automatically start playing due to the useVideoPlayer configuration
        } catch (error) {
            console.error('Error loading video:', error);
            Alert.alert(
                'Error',
                'Failed to load media item. Please try again.',
                [{text: 'OK'}]
            );
        } finally {
            setIsLoading(false);
        }
    };

    const blurhash = item.imageBlurhash && item.imageBlurhash !== 'undefined' ? item.imageBlurhash : 'LKO2?U%2Tw=w]~RBVZRi};RPxuwH';

    // Show thumbnail with play button
    return (
        <View style={styles.container}>
            <TouchableOpacity
                style={styles.thumbnail}
                onPress={handleDownloadPress}
                disabled={isLoading}
            >
                <Image
                    source={item.image.lg}
                    style={styles.previewImage}
                    placeholder={{blurhash}}
                    contentFit="cover"
                    transition={200}
                />

                <View style={styles.openButton}>
                    {isLoading ? (
                        <LoadSpinner size={80}/>
                    ) : (
                        <OpenButton size={80} onPress={handleDownloadPress}/>
                    )}
                </View>
            </TouchableOpacity>
        </View>
    );
};

const createStyles = (theme: ThemeType) => StyleSheet.create({
    container: {
        width: '100%',
        height: 250,
        backgroundColor: '#000',
        position: 'relative',
    },
    thumbnail: {
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
    },
    previewImage: {
        width: '100%',
        height: '100%',
        position: 'absolute',
    },
    openButton: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});
